function openMenu() {
  if ( document.querySelector(".slide-nav__overflow.slide-nav__overflow--thumb").classList.contains("js-menu--is-open") === true ){
    document.querySelector(".croix-menu svg").innerHTML = '<rect y="1" width="20" height="1" fill="black"/><rect y="9" width="20" height="1" fill="black"/><rect y="17" width="20" height="1" fill="black"/>';
    document.querySelector(".slide-nav__overflow.slide-nav__overflow--thumb").classList.remove("js-menu--is-open");
    document.querySelector("header.site-header").classList.remove("is-open");
  }else{
    document.querySelector(".croix-menu svg").innerHTML = '<g clip-path="url(#clip0_2650_18)"><rect x="0.863281" width="26.8487" height="1" transform="rotate(45 0.863281 0)" fill="black"/><rect x="19.8477" y="0.707031" width="26.8487" height="1" transform="rotate(135 19.8477 0.707031)" fill="black"/></g><defs><clipPath id="clip0_2650_18"><rect width="20" height="20" fill="white"/></clipPath></defs>';
    document.querySelector(".slide-nav__overflow.slide-nav__overflow--thumb").classList.add("js-menu--is-open");
    document.querySelector("header.site-header").classList.add("is-open");
  }
};

var width_screen = window.innerWidth;
if (width_screen < 768) {
  var imagesProduits = document.querySelectorAll('.product__photos .flickity-slider img');
  for (var i = 0; i < imagesProduits.length; i++) {
    imagesProduits[i].addEventListener('click', function(event) {
      const dots = document.querySelectorAll('.flickity-page-dots .dot');
      let currentIndex = -1;
      dots.forEach((dot, index) => {
          if (dot.classList.contains('is-selected')) {
              currentIndex = index;
          }
      });
      let nextIndex = (currentIndex + 1) % dots.length;
      dots[nextIndex].click();
    });
  }
}


if (!!document.querySelector(".sticky-add-to-cart .btn") === true){
  document.querySelector(".sticky-add-to-cart .btn").onclick = function() {
    document.querySelector('button.add-to-cart[type="submit"]').click();
  };
}

// Footer hover dropdowns
document.querySelectorAll('[data-section-type="footer-section"] details[data-hover="true"]').forEach(function(detail) {
  var summary = detail.querySelector('summary');
  var summaryLink = summary.dataset.link;

  summary.addEventListener('click', function(e) {
    e.preventDefault();
    if (summaryLink) {
      window.location.href = summaryLink;
    }
  });

  detail.addEventListener('mouseover', function() {
    if (!detail.hasAttribute('open')) {
      detail.setAttribute('open', '');
    }
  });

  detail.addEventListener('mouseleave', function() {
    if (detail.hasAttribute('open')) {
      detail.removeAttribute('open');
    }
  });
});

// Prevent cart drawer from auto-opening on add-to-cart (mobile only)
// We temporarily patch the drawer's open() method instead of blocking the event,
// so that buildCart() still runs and the cart content stays in sync.
(function() {
  var drawerEl = document.getElementById('CartDrawer');
  if (!drawerEl) return;

  document.addEventListener('ajaxProduct:added', function() {
    if (window.innerWidth >= 769) return;
    // Close the drawer immediately if theme.js opened it
    requestAnimationFrame(function() {
      drawerEl.classList.remove('drawer--is-open');
      drawerEl.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open-cart');
    });
  });
})();

// Hide cart badge when count is 0
(function() {
  function syncBadge() {
    document.querySelectorAll('.cart-link__bubble-num').forEach(function(el) {
      var count = parseInt(el.textContent, 10);
      var bubble = el.closest('.cart-link__bubble');
      if (bubble) {
        bubble.style.display = (!count || count <= 0) ? 'none' : '';
      }
    });
  }
  syncBadge();
  new MutationObserver(syncBadge).observe(document.body, { subtree: true, characterData: true, childList: true });
})();

window.addEventListener("load", (event) => {
  if (!!document.querySelector(".btn.klaviyo-bis-trigger") === true){
    var textBtn = document.querySelector(".product-single__form .btn.add-to-cart").textContent;
    if ( textBtn.includes("rupture") ){
      document.querySelector('.sticky-add-to-cart .rupture').style.cssText = "display: block !important;";
    }else{
      document.querySelector('.sticky-add-to-cart .rupture').style.cssText = "none: block !important;";
    }
    document.querySelector(".sticky-add-to-cart .rupture").onclick = function() {
      document.querySelector('.btn.klaviyo-bis-trigger').click();
    };
  }
});